import { PencilSimpleLine, UsersThree } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { Tag } from "common/components/ui/Tag";
import { useCampaignContext } from "common/helpers/CampaignContext";

export default function AudienceInfo() {
  const { target_count: targetCount } = useCampaignContext();

  return (
    <section className="flex items-center gap-x-2 rounded-3xl border border-black-200 p-3">
      <div className="flex flex-col gap-y-0.5">
        <h4 className="text-button-md">Audience</h4>

        <p className="text-xs text-black-500">
          LinkedIn accounts you will target with this campaign
        </p>
      </div>

      <div className="ml-auto flex items-center gap-x-2.5">
        <Tag
          size="lg"
          variant="quaternary"
          leftIcon={<UsersThree weight="fill" />}
        >
          {targetCount}
        </Tag>

        <div className="h-10 w-px bg-black-200" />

        <Button intent="iconOnly" variant="secondary-black" asChild>
          <Link to="./audience">
            <PencilSimpleLine />
          </Link>
        </Button>
      </div>
    </section>
  );
}
